import { createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/icons/icon-phone.svg'
import _imports_1 from '@/assets/icons/icon-mail.svg'
import _imports_2 from '@/assets/icons/icon-sphere.svg'


const _hoisted_1 = {
  key: 0,
  class: "page-wr"
}
const _hoisted_2 = { class: "contacts-details-header" }
const _hoisted_3 = { class: "breadcrumb-wrapper" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "checked"
}
const _hoisted_6 = {
  key: 0,
  class: "badge badge--breadcrumbs waitlist"
}
const _hoisted_7 = {
  key: 0,
  class: "business-wr"
}
const _hoisted_8 = { class: "business" }
const _hoisted_9 = {
  key: 1,
  class: "button-wrapper"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "card" }
const _hoisted_13 = {
  key: 0,
  class: "content-details-wrapper"
}
const _hoisted_14 = { class: "block-contact-information" }
const _hoisted_15 = { class: "block-contact-information_header" }
const _hoisted_16 = {
  key: 0,
  class: "avatar"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "user-info--name" }
const _hoisted_19 = { class: "contact-information-wrapper" }
const _hoisted_20 = {
  key: 0,
  class: "row-information"
}
const _hoisted_21 = { class: "row-information__text" }
const _hoisted_22 = {
  key: 1,
  class: "row-information"
}
const _hoisted_23 = { class: "row-information__text" }
const _hoisted_24 = {
  key: 2,
  class: "row-information"
}
const _hoisted_25 = { class: "row-information__text" }
const _hoisted_26 = { class: "block-switch" }
const _hoisted_27 = { class: "switch-item--text" }
const _hoisted_28 = { class: "block-switch--container" }
const _hoisted_29 = { class: "block-switch--container" }
const _hoisted_30 = { class: "block-status" }
const _hoisted_31 = { class: "block-status-section" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "row-value" }
const _hoisted_34 = {
  key: 0,
  class: "row"
}
const _hoisted_35 = { class: "row-value" }
const _hoisted_36 = { class: "block-status-section" }
const _hoisted_37 = {
  key: 0,
  class: "row"
}
const _hoisted_38 = {
  key: 1,
  class: "row"
}
const _hoisted_39 = { class: "lot-preferences--item" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "row-value" }
const _hoisted_42 = {
  key: 2,
  class: "row"
}
const _hoisted_43 = { class: "lot-preferences--item" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "row-value" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "row-value" }
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "row-value" }
const _hoisted_50 = {
  key: 1,
  class: "spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (!$setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode($setup["Breadcrumbs"], {
              crumbs: $setup.crumbs,
              backButton: false,
              crumbLabel: false,
              onSelected: _cache[0] || (_cache[0] = (route) => $setup.router.replace(route))
            }, null, 8, ["crumbs"]),
            _createVNode($setup["DropDown"], null, {
              control: _withCtx(() => [
                ($setup.userInfo)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["badge badge--breadcrumbs", $setup.getLeadStatusClass($setup.userInfo.status)])
                    }, _toDisplayString($setup.userInfo.status), 3))
                  : _createCommentVNode("", true)
              ]),
              dropdown: _withCtx(() => [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values($setup.LeadStatus), (status) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "dropdown-status-item",
                      key: status,
                      onClick: ($event: any) => ($setup.setLeadStatus(status))
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["badge", $setup.getLeadStatusClass(status)])
                      }, _toDisplayString(status), 3),
                      ($setup.userInfo.status === status)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_4))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            ($setup.inWaitList)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Waitlist"))
              : _createCommentVNode("", true)
          ]),
          ($setup.userInfo?.business)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString($setup.capitalizeString($setup.userInfo.business?.name)), 1)
              ]))
            : _createCommentVNode("", true),
          ($setup.estate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_router_link, {
                  class: "button default edit",
                  to: { name: 'LeadUpdate', params: { id: $setup.leadId } }
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode("Edit", -1)
                  ]))]),
                  _: 1
                }, 8, ["to"]),
                (!$setup.isEstateCollaborator)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (!$setup.inWaitList)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "button default primary add-btn-primary",
                            onClick: $setup.inviteToWaitlist,
                            disabled: $setup.disableInvite
                          }, "Invite to waitlist", 8, _hoisted_11))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "button default primary",
                            onClick: $setup.removeFromWaitlist
                          }, "Remove from waitlist"))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "button default primary share",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showShareModal = true))
                }, "Share reserve link")
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          ($setup.userInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    (!$setup.userInfo?.avatar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(`${$setup.userInfo?.firstName[0] || ""}${$setup.userInfo?.lastName[0] || ""}`), 1))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          class: "avatar",
                          src: $setup.userInfo?.avatar
                        }, null, 8, _hoisted_17)),
                    _createElementVNode("div", _hoisted_18, _toDisplayString(`${$setup.userInfo.value?.firstName || ""} ${$setup.userInfo.value?.lastName || ""}`), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(["badge", $setup.getLeadStatusClass($setup.userInfo.status)])
                    }, _toDisplayString($setup.userInfo.status), 3)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "card-subtitle-bold" }, "Contact Information", -1)),
                    ($setup.userInfo?.phone)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "row-information__icon" }, [
                            _createElementVNode("img", { src: _imports_0 })
                          ], -1)),
                          _createElementVNode("div", _hoisted_21, _toDisplayString($setup.userInfo?.phone), 1)
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.userInfo?.email)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "row-information__icon" }, [
                            _createElementVNode("img", { src: _imports_1 })
                          ], -1)),
                          _createElementVNode("div", _hoisted_23, _toDisplayString($setup.userInfo?.email), 1)
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.showPostcodeOrState)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "row-information__icon" }, [
                            _createElementVNode("img", { src: _imports_2 })
                          ], -1)),
                          _createElementVNode("div", _hoisted_25, _toDisplayString($setup.userInfo?.postcode ?? $setup.userInfo?.state), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode($setup["SwitchComponent"], {
                    modelValue: $setup.currentTab,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.currentTab) = $event)),
                    list: $setup.tabs,
                    customSwitches: ['active'],
                    slots: ['customSwitch']
                  }, {
                    customSwitch: _withCtx((item) => [
                      _createElementVNode("div", _hoisted_27, _toDisplayString(item.label), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _withDirectives(_createElementVNode("div", _hoisted_28, [
                    ($setup.userInfo.source === $setup.LeadSourceEnum.REA && $setup.userInfo?.data)
                      ? (_openBlock(), _createBlock($setup["EnquiriesREA"], {
                          key: 0,
                          userInfo: $setup.userInfo
                        }, null, 8, ["userInfo"]))
                      : (_openBlock(), _createBlock($setup["Enquiries"], { key: 1 }))
                  ], 512), [
                    [_vShow, $setup.currentTab.label === 'ENQUIRIES']
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_29, [
                    _createVNode($setup["Notes"], { estate: $setup.estate }, null, 8, ["estate"])
                  ], 512), [
                    [_vShow, $setup.currentTab.label === 'NOTES']
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "block-title" }, "Other information", -1)),
                    _createElementVNode("div", _hoisted_32, [
                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "row-title" }, "Source:", -1)),
                      _createElementVNode("div", _hoisted_33, _toDisplayString($setup.userInfo?.source === $setup.LeadSourceEnum.INITIAL_HOLD ? "Hold Request" : $setup.userInfo?.source), 1)
                    ]),
                    ($setup.userInfo?.holderType)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "row-title" }, "Buyer Type:", -1)),
                          _createElementVNode("div", _hoisted_35, _toDisplayString($setup.userInfo?.holderType), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "block-title" }, "Lot preferences", -1)),
                    (!$setup.lotPrferences?._id && !$setup.userInfo.preferredLot)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [...(_cache[12] || (_cache[12] = [
                          _createElementVNode("div", { class: "row-information__text size-small color-muted" }, "No lot preferences yet", -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    ($setup.userInfo.preferredLot)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "row-title" }, "Prefferred Lots:", -1)),
                              _createElementVNode("div", _hoisted_41, _toDisplayString($setup.userInfo.preferredLot), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.lotPrferences?._id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "row-title" }, "Lot size, m2:", -1)),
                              _createElementVNode("div", _hoisted_45, _toDisplayString($setup.formatPrice($setup.lotPrferences.lotSize?.from, false)) + " - " + _toDisplayString($setup.formatPrice($setup.lotPrferences.lotSize?.to, false)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_46, [
                              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "row-title" }, "Frontage, m:", -1)),
                              _createElementVNode("div", _hoisted_47, _toDisplayString($setup.formatPrice($setup.lotPrferences.frontage?.from, false)) + " - " + _toDisplayString($setup.formatPrice($setup.lotPrferences.frontage?.to, false)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_48, [
                              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "row-title" }, "Budget:", -1)),
                              _createElementVNode("div", _hoisted_49, _toDisplayString($setup.formatPrice($setup.lotPrferences.budget?.from)) + " - " + _toDisplayString($setup.formatPrice($setup.lotPrferences.budget?.to)), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode($setup["ShareLotsModal"], {
          isOpen: $setup.showShareModal,
          leadIds: [$setup.leadId],
          estateId: $setup.estateId,
          onClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.showShareModal = false))
        }, null, 8, ["isOpen", "leadIds", "estateId"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_50))
}